import { clientEnv } from '@/env.client'

const STAGING_BRANCH = 'staging'

export function getSentryEnvironment() {
  return clientEnv.NEXT_PUBLIC_PGEE_APP_ENV || 'development'
}

export function isVerboseSentryEnvironment() {
  const environment = getSentryEnvironment()

  return environment === STAGING_BRANCH
}
